import { render, staticRenderFns } from "./GanttPage.vue?vue&type=template&id=37041ea0&scoped=true&lang=pug&"
import script from "./GanttPage.vue?vue&type=script&lang=js&"
export * from "./GanttPage.vue?vue&type=script&lang=js&"
import style0 from "./GanttPage.vue?vue&type=style&index=0&id=37041ea0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37041ea0",
  null
  
)

export default component.exports